import React, { FC } from 'react';

import { Button, Result } from 'antd';

import YourCentinelHorizontalBlueHelm from '@assets/images/YourCentinelHorizontalBlueHelm.png';
import { NavLink } from 'react-router-dom';

interface NotFoundProps {}

export const NotFound: FC<NotFoundProps> = () => {
  return (
    <Result
      title={<span className="text-5xl">404</span>}
      icon={
        <img
          src={YourCentinelHorizontalBlueHelm}
          alt="YourCentinel logo"
          className="w-80"
        />
      }
      subTitle="Sorry, the page you visited does not exist."
      className="mt-36"
      extra={
        <NavLink to="/" className="">
          <Button type="primary">Back Home</Button>
        </NavLink>
      }
    />
  );
};
